export class CourierFinancialDeliveryItem {
  deliveryId: number

  orderId: number

  courierAmount: number

  updatedAt: Date

  constructor(data: Partial<CourierFinancialDeliveryItem> = {}) {
    this.deliveryId = data.deliveryId ?? -1

    this.orderId = data.orderId ?? -1

    this.courierAmount = Number(data.courierAmount ?? 0)

    this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : new Date()
  }
}
